import { useEffect, useState } from "react";
import { fetchVideos } from "../../api/educationalContentApi";
import { filterEducationalContent } from "../../utils/filterEducationalContent";
import { getMedicalConditions } from '../../api/medicalConditionApi';
import { getSurgeries } from '../../api/surgeryApi';

export default function VideoGuides({ userId }) {
    const [filteredVideos, setFilteredVideos] = useState([]);
    const [userConditions, setUserConditions] = useState(null);

    useEffect(() => {
        const fetchUserConditions = async () => {
            try {
                const medicalConditions = await getMedicalConditions(userId);
                const surgeries = await getSurgeries(userId);
                const allConditions = [
                    ...medicalConditions.map(c => c.condition_name.toLowerCase()),
                    ...surgeries.map(s => s.surgery_name.toLowerCase())
                ];

                setUserConditions(allConditions);
            } catch (error) {
                console.error("Error fetching health data:", error);
            }
        };

        fetchUserConditions();
    }, [userId]);


    useEffect(() => {
        if (userConditions === null) return;

        const fetchUserVideos = async () => {
            try {
                const data = await fetchVideos();

                const filtered = filterEducationalContent(data, userConditions);
                setFilteredVideos(filtered);
            } catch (error) {
                console.error("Error fetching videos:", error);
            }
        }

        fetchUserVideos();
    }, [userConditions]);

    if (userConditions === null) return <div>Loading user data...</div>;
    if (!filteredVideos.length) return <div className="mb-2">No videos available.</div>;

    return (
        <section>
            <div className="mb-8">

                <div className="flex gap-4 overflow-x-auto">
                    {filteredVideos.map((video, index) => (
                        <div
                            key={index}
                            className="min-w-[300px] p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow"
                        >
                            <h4 className="font-bold text-[#04395b] mb-2">
                                {getSourceName(video.url)}
                            </h4>
                            <div className="aspect-video mb-4">
                                <iframe
                                    className="w-full h-full rounded"
                                    src={getEmbedUrl(video.url)}
                                    title={video.title}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <p className="text-gray-600">{video.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

function getSourceName(url) {
    try {
        const domain = new URL(url).hostname;
        if (domain.includes("youtube")) return "YouTube";
        return domain.replace("www.", "");
    } catch {
        return "Source";
    }
}

function getEmbedUrl(url) {
    try {
        const parsedUrl = new URL(url);
        if (parsedUrl.hostname.includes("youtube.com")) {
            const videoId = parsedUrl.searchParams.get("v");
            return `https://www.youtube.com/embed/${videoId}`;
        }
        if (parsedUrl.hostname.includes("youtu.be")) {
            const videoId = parsedUrl.pathname.slice(1);
            return `https://www.youtube.com/embed/${videoId}`;
        }
        if (parsedUrl.hostname.includes("vimeo.com")) {
            const videoId = parsedUrl.pathname.split("/").pop();
            return `https://player.vimeo.com/video/${videoId}`;
        }
        return url;
    } catch {
        return url;
    }
}
